// JOBE-0168: EntityBrowserPage — top-level route component for
// `/entities`. The Entity Browser is the power-user / operational
// surface for cross-type entity browsing (contrast with the Library at
// `/library`, which is narrowed to document-shaped entities).
//
// Composition per spec §Route and shell:
//   - EntityTypesProvider mounts so the rail's type block can render
//     all registered entity types (sourced from `entity-types:list`).
//   - CollectionsProvider mounts so the shared chip row's `in:` value
//     popover has its provider context (even though the Collections
//     drawer block is out of scope in v1 — see spec §Out of scope).
//   - DocumentKindsProvider is NOT mounted — the Entity Browser type
//     rail is sourced from EntityTypesContext (`entity-types:list`),
//     not from `documents:list-kinds`.
//   - <EntityBrowser> is mounted with no `anchor` (the route exposes the
//     full graph) and no `urlStateNamespace` (single instance — URL
//     keys stay unprefixed for clean deep-links).
//   - The rail slot is the new <EntityBrowserRail> (saved views + type
//     block + register-new-kind affordance; no Collections block).

import { useMemo } from 'react';
import { EntityBrowser } from './entitybrowser/EntityBrowser.jsx';
import { EntityBrowserRail } from './entitybrowser/EntityBrowserRail.jsx';
import { EntityTypesProvider } from './library/EntityTypesProvider.jsx';
import { CollectionsProvider } from './library/CollectionsProvider.jsx';
import { useStore } from './lib/store.js';
import './library/library.css';

export function EntityBrowserPage() {
  return (
    <EntityTypesProvider>
      <CollectionsProvider>
        <EntityBrowserPageInner />
      </CollectionsProvider>
    </EntityTypesProvider>
  );
}

function EntityBrowserPageInner() {
  // Roster for the chip composer's PeopleValuePopover (the ChipRow
  // inside <EntityBrowser> requires it). Humans have no BFF endpoint
  // yet — empty array, gracefully handled.
  const agentsList = useStore((s) => s.agents.list);
  const roster = useMemo(
    () => ({ humans: [], agents: agentsList || [] }),
    [agentsList],
  );

  return (
    <div className="library-page" data-testid="entity-browser-page">
      <EntityBrowser
        roster={roster}
        rail={<EntityBrowserRail />}
        header={<EntityBrowserHeader />}
      />
    </div>
  );
}

function EntityBrowserHeader() {
  return (
    <header className="library-page-header">
      <h1 className="library-page-title">Entities</h1>
    </header>
  );
}
